module.exports = __webpack_public_path__ + "assets/media/link-copied.764d5785.svg";